import styled from 'styled-components';

export const ModalContent = styled.div`
  box-sizing: border-box;
  width: min(440px, 75vw);
  padding: 1.5rem;
`;
